var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-task-history" }, [
    _c("h3", { staticClass: "title" }, [
      _vm._v("Automation Plan & Task History"),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-wrapper" },
      [
        _c("div", { staticClass: "toolbar" }, [
          _c(
            "div",
            { staticClass: "left" },
            [
              _c("a-input-search", {
                staticClass: "row search-input",
                staticStyle: { width: "300px" },
                attrs: { placeholder: _vm.$t("message.startFilter") },
                on: {
                  input: function ($event) {
                    return _vm.onSearch($event.target.value)
                  },
                },
                model: {
                  value: _vm.searchText,
                  callback: function ($$v) {
                    _vm.searchText = $$v
                  },
                  expression: "searchText",
                },
              }),
              _vm._v(" "),
              _c("CommonFilterTool", {
                attrs: {
                  "keep-state-on-query-params": false,
                  "filter-meta": _vm.filterMetas,
                  "label-formatter": _vm.filterLabelFormatter,
                },
                on: { addFilter: _vm.addFilter },
                model: {
                  value: _vm.breakdownFilter,
                  callback: function ($$v) {
                    _vm.breakdownFilter = $$v
                  },
                  expression: "breakdownFilter",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "right" }),
        ]),
        _vm._v(" "),
        _c("SupsisTable", {
          attrs: {
            columns: _vm.getCols(),
            rows: _vm.items,
            "top-pagination": "",
            "empty-data-bordered": "",
            "bottom-pagination": "",
            "pagination-cursor": _vm.pagination,
            options: {
              checkboxOption: _vm.checkboxOption,
              rowStyleOption: _vm.rowStyleOption,
              clipboardOption: _vm.clipboardOption,
              fixedHeader: true,
              id: "automation-table",
              borderX: true,
              borderY: true,
            },
          },
          on: {
            "cursor-changed": function (cursor) {
              return (_vm.pagination = cursor)
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }